module.exports = __webpack_public_path__ + "static/media/RateFood_Outro.5946c535.png";